import React, { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Pourquoi nous", href: "#pourquoi" },
  { label: "Galerie", href: "#galerie" },
  { label: "Zone", href: "#zone" },
  { label: "Tarifs", href: "#tarifs" },
  { label: "Avis", href: "#avis" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#" data-testid="header-logo-link" className="flex items-center">
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-neutral-300 hover:text-[#FFD600] transition-colors uppercase tracking-wider"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:+33620735220"
            data-testid="header-call-button"
            className="hidden sm:inline-flex items-center gap-2 bg-[#FFD600] hover:bg-[#FACC15] text-[#0A0A0A] font-bold px-5 py-3 rounded-md uppercase tracking-wide text-sm transition-all hover:scale-[1.02] glow-yellow"
          >
            <Phone className="w-4 h-4" strokeWidth={3} />
            06 20 73 52 20
          </a>

          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2 border border-white/15 rounded-md"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-3 px-4 text-neutral-300 hover:text-[#FFD600] hover:bg-white/5 rounded-md uppercase tracking-wider text-sm font-medium"
              >
                {n.label}
              </a>
            ))}
            <a
              href="tel:+33620735220"
              data-testid="mobile-call-button"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#FFD600] text-[#0A0A0A] font-bold px-5 py-4 rounded-md uppercase tracking-wide"
            >
              <Phone className="w-4 h-4" strokeWidth={3} />
              06 20 73 52 20
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
